export const ProjectValidation = (formData) => {
    const errors = {};
  
    // Validate each field
    if (!formData.ProjectName.trim()) {
      errors.ProjectName = 'Project Name is required';
    } 
    
  
    return errors;
  };
  
 